<template>
  <div class="star-rating whitespace-no-wrap">
    <label
      v-for="rating in length"
      :key="rating"
      :class="{
        'is-selected': value >= rating,
      }"
      class="star-rating__star"
    >
      ★
    </label>
  </div>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    value: { type: [Number, String], default: 0 },
    length: { type: Number, default: 5 },
  },
}
</script>
